const LIKED_CLASS_NAME = "like--liked";

/** いいねボタン */
class LikeButton extends HTMLElement {
  constructor() {
    super();

    this.handle = this.dataset.handle;
    this.isLiked = this.checkLiked(this.handle);
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.isLiked) {
        this.unlike(this.handle);
        this.isLiked = false;
      } else {
        this.like(this.handle);
        this.isLiked = true;
      }
    });
  }

  /** 現在のいいね状態を判定 */
  checkLiked(handle) {
    const likeHandles = loadLocalStorage(LOCAL_STORAGE_KEY.LIKE) || [];
    const isLiked = likeHandles.includes(handle);
    if (isLiked) {
      this.classList.add(LIKED_CLASS_NAME);
    }
    return isLiked;
  }

  /** いいね */
  like(handle) {
    if (!handle) {
      window.alert("処理に失敗しました。画面をリロードして再度お試しください。");
      console.error("Validation Error:", "[handle]", handle);
      return;
    }

    const likeHandles = loadLocalStorage(LOCAL_STORAGE_KEY.LIKE) || [];
    if (!likeHandles.includes(handle)) {
      likeHandles.push(handle);
    }
    saveLocalStorage(LOCAL_STORAGE_KEY.LIKE, likeHandles);

    this.classList.add(LIKED_CLASS_NAME);
  }

  /** いいね解除 */
  unlike(handle) {
    if (!handle) {
      window.alert("処理に失敗しました。画面をリロードして再度お試しください。");
      console.error("Validation Error:", "[handle]", handle);
      return;
    }

    const likeHandles = loadLocalStorage(LOCAL_STORAGE_KEY.LIKE) || [];
    const filteredLikeHandles = likeHandles.filter((likeHandle) => likeHandle !== handle);
    saveLocalStorage(LOCAL_STORAGE_KEY.LIKE, filteredLikeHandles);

    this.classList.remove(LIKED_CLASS_NAME);
  }
}
customElements.define('like-button', LikeButton);

/** いいね一覧取得 */
async function fetchLikeProducts() {
  const likeHandles = loadLocalStorage(LOCAL_STORAGE_KEY.LIKE) || [];
  if (!likeHandles.length) return [];

  try {
    const products = await Promise.all(likeHandles.map(async (handle) => {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        return undefined;
      }
      const product = await response.json();
      return product;
    }));
    return products.filter(Boolean);
  } catch (error) {
    console.error("Fetch Error:", "[fetchLikeProducts]", error);
    return [];
  }
}
